import { render, staticRenderFns } from "./customerTrees.vue?vue&type=template&id=674249af&scoped=true&"
import script from "./customerTrees.vue?vue&type=script&lang=js&"
export * from "./customerTrees.vue?vue&type=script&lang=js&"
import style0 from "./customerTrees.vue?vue&type=style&index=0&id=674249af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674249af",
  null
  
)

export default component.exports